import { Badge } from "../ui/badge";
import {
    Card,
    CardContent,
    CardDescription,
    CardHeader,
    CardTitle,
} from "../ui/cards";
import {
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableHeader,
    TableRow,
} from "../ui/table";
import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import { ORDER_API } from "../../api"

export const OrdersTable = () => {

    const [orders, setOrders] = useState([{
        id: 1,
        name: "Test@123",
        email: "Henry_Baldwin640@yafr7.tech",
        oid: "UD2477000010",
        phoneNo: 123456789,
        orderDate: "01/01/2024",
        totalAmt: 46944,
        orderStatus: "Pending",
        paymentMethod: "Card",
    }]);


    useEffect(() => {
        const id = JSON.parse(localStorage.getItem("userDetails")).userid;
        fetch(ORDER_API , {
            method:"POST", 
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({cust_id:id})
        })
        .then((res) => {return res.json()})
        .then((res) => setOrders(res));
    },[])

    return (
        <Card>
            <CardHeader className="px-7">
                <CardTitle>Your Orders</CardTitle>
                <CardDescription>
                    Recent orders from your store.
                </CardDescription>
            </CardHeader>
            <CardContent>
                <Table>
                    <TableHeader>
                        <TableRow>
                            <TableHead>Order ID</TableHead>
                            <TableHead className="hidden sm:table-cell">
                                Status
                            </TableHead>
                            <TableHead className="hidden md:table-cell">
                                Date
                            </TableHead>
                            <TableHead className="text-right">Amount</TableHead>
                        </TableRow>
                    </TableHeader>
                    <TableBody>
                        {orders.map(
                            (
                                {
                                    OrderID,
                                    email,
                                    date,
                                    Status,
                                    TotalAmount,
                                },
                                id
                            ) => (
                                <TableRow
                                    key={id}
                                    className={id % 2 == 0 ? "bg-accent" : ""}
                                >
                                    <TableCell>
                                        <Link to={"/user/dashboard/orders/abc"} state={[orders, id]}>
                                            <div className="font-medium">
                                                {OrderID}
                                            </div>
                                            <div className="hidden text-sm text-muted-foreground md:inline">
                                                ff
                                            </div>
                                        </Link>
                                    </TableCell>
                                    <TableCell className="hidden sm:table-cell">
                                        <Badge
                                            className="text-xs"
                                            variant={
                                                Status == "Pending"
                                                    ? "destructive"
                                                    : Status == "Active"
                                                    ? "secondary"
                                                    : "default"
                                            }
                                        >
                                            {Status}
                                        </Badge>
                                    </TableCell>
                                    <TableCell className="hidden md:table-cell">
                                        {date}
                                    </TableCell>
                                    <TableCell className="text-right">
                                        ₹ {TotalAmount}
                                    </TableCell>
                                </TableRow>
                            )
                        )}
                    </TableBody>
                </Table>
            </CardContent>
        </Card>
    );
};
